import React from 'react';
import Icon from '../atoms/Icon';

function SpeedometerCircleIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <g 
        fill='none' 
        stroke='currentColor'
        stroke-width='2.23077'
        stroke-miterlimit='10'
      >
        <path d='M15.6154 30.1154C23.6235 30.1154 30.1154 23.6235 30.1154 15.6154C30.1154 7.60726 23.6235 1.11539 15.6154 1.11539C7.60726 1.11539 1.11538 7.60726 1.11538 15.6154C1.11538 23.6235 7.60726 30.1154 15.6154 30.1154Z'/>
        <path d='M15.6154 15.6154L22.3077 13.3846'/>
        <path d='M30.1154 15.6154H24.5385'/>
        <path d='M6.69231 15.6154H1.11538'/>
        <path d='M25.8657 5.36502L21.9284 9.30233'/>
        <path d='M15.6154 6.69231V1.11539'/>
        <path d='M9.30231 9.30233L5.365 5.36502'/>
      </g>
      
      <g 
        fill='currentColor' 
        fillRule='nonzero'
      >
        <path d='M15.6154 17.8462C16.8474 17.8462 17.8462 16.8474 17.8462 15.6154C17.8462 14.3834 16.8474 13.3846 15.6154 13.3846C14.3834 13.3846 13.3846 14.3834 13.3846 15.6154C13.3846 16.8474 14.3834 17.8462 15.6154 17.8462Z'/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(SpeedometerCircleIcon);
